export const MIN_SOCIAL_PROOF = 128;
export const MAX_SOCIAL_PROOF = 249;
